import { gql } from "@apollo/client";

export const EVER_HAD_APPOINTMENT_QUERY = gql`
  query checkEverHadAppointment {
    dashboard {
      everHadAppointment,
    }
  }
`;
